import { render, staticRenderFns } from "./ManagePositionsDialog.vue?vue&type=template&id=00ff6c72"
import script from "./ManagePositionsDialog.vue?vue&type=script&lang=ts"
export * from "./ManagePositionsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports